import React from 'react';
import { MessageCircle } from 'lucide-react';
interface WhatsAppCTAProps {
  text: string;
  location: 'hero' | 'mid' | 'pain' | 'content' | 'faq' | 'final';
  className?: string;
}
export function WhatsAppCTA({
  text,
  location,
  className = ''
}: WhatsAppCTAProps) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('trackCustom', 'WhatsAppClick', {
        location
      });
    }
  };
  return <a href="https://wa.link/sedfbn" target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold text-lg py-4 px-8 rounded-xl transition-all duration-200 shadow-[0_8px_20px_-4px_rgba(37,211,102,0.4)] hover:shadow-[0_12px_25px_-4px_rgba(37,211,102,0.6)] hover:-translate-y-1 w-full md:w-auto ${className}`} data-id="element-148">
      <MessageCircle className="w-6 h-6" data-id="element-149" />
      <span data-id="element-150">{text}</span>
    </a>;
}